import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseHorizontalNavigationComponent, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { LanguagesComponent } from 'app/layout/common/languages/languages.component';
import { MessagesComponent } from 'app/layout/common/messages/messages.component';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { QuickChatComponent } from 'app/layout/common/quick-chat/quick-chat.component';
import { SearchComponent } from 'app/layout/common/search/search.component';
import { ShortcutsComponent } from 'app/layout/common/shortcuts/shortcuts.component';
import { UserComponent } from 'app/layout/common/user/user.component';
import { Subject, takeUntil } from 'rxjs';
import { NgClass } from '@angular/common';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { MatDividerModule } from '@angular/material/divider';
import { FooterComponent } from "../../../../modules/landing/footer/footer.component";
import { ShowmyinterestComponent } from 'app/modules/auth/showmyinterest/showmyinterest.component';
import { GtmService } from 'app/core/shared-services/gtm.service';


@Component({
    selector: 'enterprise-layout',
    templateUrl: './enterprise.component.html',
    styleUrls: ['./enterprise.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatDividerModule, NgClass, FuseLoadingBarComponent, NgIf, RouterLink, FuseVerticalNavigationComponent, MatButtonModule, MatIconModule, LanguagesComponent, FuseFullscreenComponent, SearchComponent, ShortcutsComponent, MessagesComponent, NotificationsComponent, UserComponent, FuseHorizontalNavigationComponent, RouterOutlet, QuickChatComponent, FooterComponent]
})
export class EnterpriseLayoutComponent implements OnInit, OnDestroy
{
    public isScreenSmall:       boolean;
    public isLoggedIn:          boolean = false;
    public contactUsSelected:   boolean = false;
    public cartSelected:        boolean = false;
    public accountSelected:     boolean = false;
    public navigation:          Navigation;
    public cartItems:           any;
    public activePage:          any;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _matDialog = inject(MatDialog);

    /**
     * Constructor
     **/
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _webStorage: WebStorage,
        private _changeDetectorRef: ChangeDetectorRef,
        private _gtmService: GtmService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) =>
            {
                this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) =>
            {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });


            if ( sessionStorage.getItem('accessToken')) {

        // Subscribe to cart changes
        this._webStorage.CartInfo
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((cartItems) =>
            {
                this.cartItems = cartItems;
            });

            if ( sessionStorage.getItem('accessToken')) {

                this.isLoggedIn = true;
            } else {
                this.isLoggedIn = false;
            }
    }}
    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    /**
     * On check
     */
        ngDoCheck(): void
        {
            this.isLoggedIn = !!sessionStorage.getItem('accessToken');
            this.activePage = sessionStorage.getItem('ActivePage');
            if ((this._webStorage.CartInfo.value).length) {
                this.cartItems = this._webStorage.CartInfo.value;
                this._changeDetectorRef.detectChanges();
            }
        }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    //Sign out
    signOut() {
        sessionStorage.removeItem('accessToken');
        this._router.navigateByUrl('/home');
    }

    //Login click event (GTM)
    onLoginClick(clickText: string = 'Login'): void {
        this._gtmService.trackLoginClick(clickText);
    }

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    goToDashboard() {
        this.clearSelections();
        this.accountSelected = true;
        this._router.navigateByUrl('/dashboard');
    }
    

    goToCart() {
        this.clearSelections();
        this.cartSelected = true;
        this._router.navigateByUrl('/cart');
    }
     goToShowMyInterest() {
        this.clearSelections();
        this.contactUsSelected = true;
        const packageInfo = JSON.parse(sessionStorage.getItem('packageInfo'));
        const userGoogleAddress = JSON.parse(sessionStorage.getItem('CustomerGoogleAddress'));
        
        this._matDialog.open(ShowmyinterestComponent, {
            width: '600px',
            maxWidth: '95vw',
            panelClass: 'call-me-back-dialog',
            backdropClass: 'blurModalBackground',
            disableClose: true,
            data: {
                packageInfo: packageInfo,
                userGoogleAddress: userGoogleAddress
            }
        });
    }

    goToContactUs(){
        this._router.navigateByUrl('/contact');
    }

    clearSelections(){
        this.contactUsSelected = false;
        this.cartSelected = false;
        this.accountSelected = false;
    }

    /**
     * Check if footer should be shown
     * Hide footer on cart, call-me-back, contact us, order-complete, package-review; hide on eMandate on mobile
     */
    shouldShowFooter(): boolean {
        const currentUrl = this._router.url;
        if (this.isScreenSmall && currentUrl.includes('emandate')) {
            return false;
        }
        const hideFooterRoutes = ['/cart', '/call-me-back', '/contact', '/order-complete', '/package-review'];
        return !hideFooterRoutes.some(route => currentUrl.includes(route));
    }


}

function ngOnDestroy() {
    throw new Error('Function not implemented.');
}
function ngDoCheck() {
    throw new Error('Function not implemented.');
}

